import * as React from 'react';

const IconSummary = (props: React.SVGAttributes<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.055"
      height="32.07"
      viewBox="0 0 25.055 32.07"
      {...props}
    >
      <g fill="currentColor">
        <path d="M17.963 19.59a6.951 6.951 0 0 1-1.532-3.293 6.953 6.953 0 0 1-1.537 3.294 6.958 6.958 0 0 1-3.293 1.537 6.946 6.946 0 0 1 3.293 1.537 6.954 6.954 0 0 1 1.537 3.293 6.952 6.952 0 0 1 1.537-3.294 6.955 6.955 0 0 1 3.288-1.537 6.951 6.951 0 0 1-3.293-1.537ZM22.9 25.672a4.156 4.156 0 0 1-.918-1.967 3.177 3.177 0 0 1-2.885 2.886 3.178 3.178 0 0 1 2.886 2.886 3.177 3.177 0 0 1 2.885-2.886 4.155 4.155 0 0 1-1.968-.919ZM14.851 27.222a2.667 2.667 0 0 1-2.422 2.423 2.668 2.668 0 0 1 2.423 2.423 2.668 2.668 0 0 1 2.422-2.423 2.667 2.667 0 0 1-2.423-2.422Z" />
        <path d="M4.618 31.937h8.163a8.226 8.226 0 0 1-1.951-2.4H4.752a2.074 2.074 0 0 1-2.354-2.279V4.722a2.106 2.106 0 0 1 2.354-2.324h15.566a2.115 2.115 0 0 1 2.339 2.324v12.989a8.176 8.176 0 0 1 2.4 1.936V4.677q0-4.67-4.618-4.677H4.618C1.549 0 0 1.579 0 4.677v22.6c0 3.111 1.549 4.66 4.618 4.66ZM6.897 8.476h11.291a.922.922 0 0 0 .924-.938.894.894 0 0 0-.924-.894H6.897a.889.889 0 0 0-.938.894.916.916 0 0 0 .938.938Zm0 5.2h11.291a.922.922 0 0 0 .924-.938.894.894 0 0 0-.924-.894H6.897a.889.889 0 0 0-.938.894.916.916 0 0 0 .938.936Z" />
      </g>
    </svg>
  );
};

export default IconSummary;
